import {SxProps, Theme} from '@mui/material';

/**
 * One column on a phone, two from 600px up. A tablet used to get the phone's single column stretched
 * across the whole screen, which left half of it empty and every card twice as wide as it needs.
 */
export const cardListSx: SxProps<Theme> = {
    display: 'grid',
    gridTemplateColumns: {xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))'},
    alignItems: 'start',
    gap: '10px',
    width: '100%',
};
